import React, { Component } from "react";
import styles from "../../assets/css/estilo.css";

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Slide from "../../components/slide";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";

import myVideo from "../../assets/img/ecossitema-2.mp4";


class Home extends Component {
  
    render() {
      return (
          <React.Fragment>
              <Headbody></Headbody>
              <Menu></Menu>
              <Slide></Slide>
                <section class="content-home">
                    <div class="container">
                        <div class="row d-flex align-items-center">
                            <div class="col-12 cont-home">
                                <h2>Somos especialistas em ajudar <b>clínicas, hospitais e laboratórios</b></h2>

                                <p>Podemos melhorar seus processos e principalmente a experiência na jornada do paciente e dos profissionais de saúde.</p>         
                            </div>

                            <div class="col-12 col-lg-5">
                                <img src={"../assets/img/img-sobre.svg"} alt={"Imagens de IoT"} ></img>
                            </div>

                            <div class="col-12 col-lg-7">
                                <p>Com uso de <b>tecnologia aplicada à saúde</b>, tal como <b>IoT - Internet das Coisas</b>,  reduzimos o tempo de espera do paciente, otimizamos o tempo dos profissionais de saúde e uso dos equipamentos de diagnósticos.</p>

                                <p>Usar tecnologia aplicada à saúde está cada vez mais relevante para <b>melhorar a experiencia do paciente, a experiencia de trabalho do corpo clínico e de seus colaboradores</b>, aumentando a produtividade com soluções rápidas, simples e aprovadas.</p>
                            
                                <div id="accordionIot" class="row m-auto">
                                    <div id="Iot_oquee" class="col-6">
                                        <a href="#" class="btn-itm" data-toggle="collapse" data-target="#IOTOQUEE" aria-expanded="true" aria-controls="IOTOQUEE">O que é IoT?</a>
                                    </div>

                                    <div id="Iot_saude" class="col-6">
                                        <a href="#" class="btn-itm" data-toggle="collapse" data-target="#IOTSAUDE" aria-expanded="true" aria-controls="IOTSAUDE">IoT na Saúde</a>
                                    </div>

                                    <div id="IOTOQUEE" class="collapse melhoria-collapse mt-3" aria-labelledby="Iot_oquee" data-parent="#accordionIot">
                                        <div class="card-body">
                                            <p>O termo "Internet of Things" (loT) ou “Internet das Coisas” é usado para descrever a  conectividade entre  objetos físicos ou até mesmo pessoas com a internet.</p>

                                            <p>É a digitalização do mundo real!</p>

                                            <p>A “Internet das Coisas” permite que você tenha análise em tempo real com registro constante de dados e informações sobre objetos e pessoas, revolucionando o modo como vivemos e facilitando  a nossa vida.</p>
                                        </div>
                                    </div>

                                    <div id="IOTSAUDE" class="collapse melhoria-collapse mt-3" aria-labelledby="Iot_saude" data-parent="#accordionIot">
                                        <div class="card-body">
                                            <p>O IoT - Internet das Coisas está transformando como os dispositivos interagem com sistemas e as pessoas em vários segmentos do mercado e na área da saúde por exemplo, permite localizar pacientes, colaboradores e equipamentos em tempo real, com facilidade, precisão e melhorando processos.</p>

                                            <p>Com uso de tecnologia IoT aplicada à saúde, reduzimos o tempo de espera do paciente, otimizamos o tempo dos profissionais de saúde e uso dos equipamentos de diagnósticos.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row d-lg-flex align-items-lg-center mt-5">
                            <div class="col-12 col-lg-4 m-auto">
                            <img src={"../assets/img/itechflow.svg"} alt={"Imagens do ITechFlow"} class="img-fluid"></img>
                            </div>

                            <div class="col-12 col-lg-8">
                            <p>A <b>Itech<span class="azul">MED</span></b> desenvolveu a plataforma de soluções <b>Itech<span class="azul">Flow</span></b> que coleta e registra os dados dos dispositivos em nuvem.</p>

                            <p>Usando ferramenta de BI transforma informação em resultados que disponibiliza por meio de dash-board, relatórios e alertas, que são fundamentais para melhorar a gestão e eficiência nos processos e a utilização de recursos.</p>
                            </div>
                        </div>    
                </div>
            </section>

            <section class="ecossistema">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                        <h2>AMBIENTE <b>ITech<span>Flow</span></b></h2>
                        
                        <video width="100%" autoPlay muted loop class="rounded">
                            <source src={myVideo} type="video/mp4"></source>
                        </video>
                        {/* <!-- <img src="assets/img/ecossistema.svg" alt="Ecossistema ITechFlow" class="img-fluid"> --> */}
                        </div>
                    </div>
                </div>
            </section>

            {/* <?php require("modulos/dev-solucoes.php"); ?> */}
            <Devsolucoes></Devsolucoes>

                <section class="melhoria">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-lg-5">
                            <div class="melhoria-conteudo-principal">
                                <img src={"../assets/img/ico-melhoria-02.svg"} alt=""></img>
                                <h3 class="roxo">Jornada do Paciente</h3>
                                <p>Soluções dedicadas a melhorar a experiência na jornada do paciente, garantindo agilidade no atendimento, menor tempo de espera e mais atenção ao paciente.</p>
                            </div>
                            </div>

                            <div class="col-12 col-md-6 offset-md-1" id="accordionMelhoria">
                            <div id="mlhJornada">
                                <div class="melhoria-item" data-toggle="collapse" data-target="#mlh_jornada" aria-expanded="true" aria-controls="mlh_jornada">
                                    <img src={"../assets/img/solucoes/ico-solucoes_gestao-de-jornada.svg"} alt=""></img>
                                    <p>Solução de atendimento e gestão Check-up</p>
                                </div>
                            </div>

                            <div id="mlh_jornada" class="collapse melhoria-collapse" aria-labelledby="mlhJornada" data-parent="#accordionMelhoria">
                                <div class="card-body">
                                    <p>Nossa solução de atendimento e gestão Check-up foi desenvolvido com o objetivo de assegurar o controle e orientação de pacientes dentro de um fluxo continuo de exames.</p>

                                    <a href="/atendimento-de-check-up" class="btn-itm-roxo">Conheça Mais</a>
                                </div>
                            </div>

                            <div id="mlhFluxo">
                                <div class="melhoria-item" data-toggle="collapse" data-target="#mlh_fluxo" aria-expanded="true" aria-controls="mlh_fluxo">
                                    <img src={"../assets/img/solucoes/ico-solucoes_fluxo.svg"} alt=""></img>
                                    <p>Solução para atendimento em Clinicas Radiológicas</p>
                                </div>
                            </div>

                            <div id="mlh_fluxo" class="collapse melhoria-collapse" aria-labelledby="mlhFluxo" data-parent="#accordionMelhoria">
                                <div class="card-body">
                                    <p>Nossa solução foi desenvolvida com o objetivo de melhorar o fluxo de atendimento dentro de clinicas radiológicas, desde o momento da entrada do paciente até o final de todo o ciclo de exames.</p>
                                    <a href="/atendimento-clinicas" class="btn-itm-roxo">Conheça Mais</a>
                                </div>
                            </div>
                            </div> 
                        </div>



                        <div class="melhoria-processo section-plans" id="section-plans">
                            <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="melhoria-conteudo-principal">
                                    <img src={"../assets/img/ico-melhoria-01.svg"} alt=""></img>
                                    <h3 class="azul">Melhoria de Processos</h3>
                                    <p>Soluções dedicadas para melhorar a gestão, garantindo a eficiência dos processos e da utilização de recursos.</p>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 pb-4">
                                <div class="cartao">
                                    <div class="cartao__side cartao__side--front-1">
                                        <div class="cartao__title cartao__title--1">
                                        <img src="assets/img/solucoes/ico-solucoes_controle-temperatura.svg" alt=""></img>
                                        <h4 class="cartao__heading">Monitoramento de Temperatura e Umidade</h4>
                                        </div>

                                        <div class="cartao__details">
                                        </div>
                                    </div>
                                    
                                    <div class="cartao__side cartao__side--back cartao__side--back-1">
                                        <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                            <p class="cartao__content-title">Monitoramento de Temperatura e Umidade</p>
                                            <p class="cartao__content-text">Solução com o objetivo de assegurar melhor monitoramento das variações de temperatura e umidade via WEB.</p>
                                        </div>
                                        <a href="/temperatura" class="btn-itm-branco">Conheça Mais</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 pb-4">
                                <div class="cartao">
                                    <div class="cartao__side cartao__side--front-1">
                                        <div class="cartao__title cartao__title--1">
                                        <img src="assets/img/solucoes/ico-solucoes_rastreabilidade.svg" alt=""></img>
                                        <h4 class="cartao__heading">Rastreabilidade de Equipamentos</h4>
                                        </div>

                                        <div class="cartao__details">
                                        </div>
                                    </div>
                                    
                                    <div class="cartao__side cartao__side--back cartao__side--back-1">
                                        <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                            <p class="cartao__content-title">Rastreabilidade de Equipamentos</p>
                                            <p class="cartao__content-text"> Solução com o objetivo de disponibilizar a localização e rastreamento de equipamentos em tempo real.</p>
                                        </div>
                                        <a href="/ativos" class="btn-itm-branco">Conheça Mais</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 pb-4">
                                <div class="cartao">
                                    <div class="cartao__side cartao__side--front-1">
                                        <div class="cartao__title cartao__title--1">
                                        <img src={"../assets/img/solucoes/ico-solucoes_gestao-de-ocupacao.svg"} alt=""></img>
                                        <h4 class="cartao__heading">Gestão de Ocupação de Leitos e Centros Cirúrgicos</h4>
                                        </div>

                                        <div class="cartao__details">
                                        </div>
                                    </div>
                                    
                                    <div class="cartao__side cartao__side--back cartao__side--back-1">
                                        <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                            <p class="cartao__content-title">Gestão de Ocupação de Leitos e Centros Cirúrgicos</p>
                                            <p class="cartao__content-text">O Módulo de Leitos e Centro Cirúrgico foi desenvolvido com o objetivo de controlar a ocupação em leitos e centros cirúrgicos...</p>
                                        </div>
                                        <a href="/leitos-e-centros-cirurgicos" class="btn-itm-branco">Conheça Mais</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 pb-4">
                                <div class="cartao">
                                    <div class="cartao__side cartao__side--front-1">
                                        <div class="cartao__title cartao__title--1">
                                        <img src={"../assets/img/solucoes/ico-solucoes_gestao-de-processo.svg"} alt=""></img>
                                        <h4 class="cartao__heading">Gestão de Processo de Limpeza</h4>
                                        </div>

                                        <div class="cartao__details">
                                        </div>
                                    </div>
                                    
                                    <div class="cartao__side cartao__side--back cartao__side--back-1">
                                        <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                            <p class="cartao__content-title">Gestão de Processo de Limpeza</p>
                                            <p class="cartao__content-text">O modulo de gestão de limpeza foi desenvolvido com o objetivo de facilitar o controle e acelerar o processo de limpeza de quartos…</p>
                                        </div>
                                        <a href="/limpeza" class="btn-itm-branco">Conheça Mais</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 col-lg-4 pb-4">
                                <div class="cartao">
                                    <div class="cartao__side cartao__side--front-1">
                                        <div class="cartao__title cartao__title--1">
                                        <img src={"../assets/img/solucoes/ico-solucoes_rfid.svg"} alt=""></img>
                                        <h4 class="cartao__heading">Soluções RFID</h4>
                                        </div>

                                        <div class="cartao__details">
                                        </div>
                                    </div>
                                    
                                    <div class="cartao__side cartao__side--back cartao__side--back-1">
                                        <div class="cartao__cta">
                                        <div class="cartao__content-box">
                                            <p class="cartao__content-title">Soluções RFID</p>
                                            <p class="cartao__content-text">A solução RFID pode ser usada em vários segmentos com inúmeras aplicações, tais como controle de enxovais, rouparias…</p>
                                        </div>
                                        <a href="/rfid" class="btn-itm-branco">Conheça Mais</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>    
                    </div>
                </section>
                <Footer></Footer>
                <Endbody></Endbody>
            </React.Fragment>
        
      );
    }
  }

export default Home;

